/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { cn } from "tailwind-variants";
import ColorPicker from "../ColorPicker.vue";
import { useDtfStore } from "../store";
import "./Color.scss";

export default function Color(props: any) {
  const { ...restProps } = props;

  const colors = [
    {
      name: "Black",
      value: "#000000"
    },
    {
      name: "White",
      value: "#FFFFFF"
    },
    {
      name: "Navy",
      value: "#03283A"
    },
    {
      name: "Red",
      value: "#D50132"
    },
    {
      name: "Gold",
      value: "#FCA311"
    },
    {
      name: "Green",
      value: "#016B3F"
    },
    {
      name: "Purple",
      value: "#514689"
    },
    {
      name: "Royal",
      value: "#082D99"
    },
    {
      name: "Gray",
      value: "#82878D"
    },
    {
      name: "Columbia",
      value: "#6887B7"
    },
    {
      name: "Orange",
      value: "#F14329"
    },
    {
      name: "Vegas Gold",
      value: "#ABA275"
    },
    {
      name: "Yellow",
      value: "#F8DC02"
    }
  ];

  const store = useDtfStore();

  function letterNumberArtwork() {
    // @ts-expect-error TS(4111): Property 'letterNumberArtwork' comes from an index... Remove this comment to see the full error message
    return store.letterNumberArtwork;
  }

  function pickerStyle() {
    return cn("jersey-numbers-color__picker", {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      "jersey-numbers-color__picker--solid": letterNumberArtwork().style === "solid"
    });
  }

  function handleSelect(color: any) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    store.updateArtworkValues({
      index: 0,
      color
    });
  }

  return (
    <div {...restProps} className={cn("jersey-numbers-color", restProps.className)}>
      <ColorPicker
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        value={letterNumberArtwork().color}
        colors={colors}
        showColorLabel={true}
        onChange={handleSelect}
        slots={{
          "picker-preview": ({ color }: any) => (
            <div
              className={pickerStyle()}
              style={{
                // @ts-expect-error TS(2571): Object is of type 'unknown'.
                color: color?.hex || color || letterNumberArtwork().color
              }}
            >
              {" "}
              12345
              <br />
              67890{" "}
            </div>
          )
        }}
        data-testid="color-picker"
      />
    </div>
  );
}
